export default __webpack_public_path__ + "static/media/myPractice_physicianVerify_x.28bc4eb3.jpg";